<template>
<div class="row columns">
     <div class="panel-content" >
        <div class="row small-up-1 medium-up-2 large-up-6">
              <div class="columns" v-for="asset in currentItems">
                <img :id="asset.name"
                      @click="onImageClicked"
                      class="thumbnail clear"
                      :src="asset.url" alt="aperçu">
              </div>
        </div>
    </div>
    <br>
    <div class="row columns">
        <div class="large-10 large-centered"></div>
        <paginate :click-handler="paginateClickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :page-count="getPageCount"
                  :container-class="'pagination'">
        </paginate>
    </div>
</div>
</template>

<script>
import modal from '../modal.vue'
import { mapGetters } from 'vuex'
import store from '../../../store/index.js'
import Paginate from 'vuejs-paginate'

export default {
  name: 'imageLibrary',
  components: {
    modal,
    Paginate
  },
  props: {
    'page': 1
  },
  methods: {
    onImageClicked (event) {
      this.$emit('imageChosen', event.target.src)
    },
    paginateClickCallback (pageNum) {
      this.currentItems = store.getters.getThumbnailPage(pageNum)
    }
  },
  created () {
    store.dispatch('refreshAllThumbnails')
    store.subscribe((mutation, state) => {
      if (mutation.type === 'addImgsList') {
        this.currentItems = store.getters.getThumbnailPage(1)
      }
    })
  },
  computed:
  {
    ...mapGetters([
      'getAllThumbnails',
      'getPageCount'
    ])
  },
  data () {
    return {
      currentItems: []
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pagination {
    display: inline-block;
}

.pagination a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    border: 1px solid #ddd;
}
.pagination a.active {
    background-color: #4CAF50;
    color: white;
}


</style>



// WEBPACK FOOTER //
// image-library.vue?0d47814e